export default "https://cdn-static.gokick.com/assets/9903fb7c557cf9d7d858f1d02aec0837d292f7c0/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";